import { toDateInputValue } from './utils';

const REFRESH_FIELDS = [
  'state',
  'maxQuantity',
  'stockQuantity',
  'preorderQuantity',
  'expectedArrivalDate',
  'personalDiscount',
  'productDiscount',
];

const availabilityChanged = (previous, current) =>
  REFRESH_FIELDS.some(key =>
    key === 'expectedArrivalDate'
      ? toDateInputValue(previous[key]) !== toDateInputValue(current[key])
      : previous[key] !== current[key],
  );

/** Refresh availability without changing what the customer requested or applying a stale response. */
export async function refreshBasketAvailability(products, fetchProduct, isCurrent) {
  const updatedProducts = [];
  const mismatches = [];
  let changed = false;
  for (const basketProduct of products) {
    if (!isCurrent()) return null;
    try {
      const data = await fetchProduct(basketProduct.id);
      if (!isCurrent()) return null;
      const current = Array.isArray(data)
        ? data.find(product => product.id === basketProduct.id)
        : data;
      if (!current) {
        updatedProducts.push(basketProduct);
        continue;
      }
      if (
        toDateInputValue(basketProduct.expectedArrivalDate) !==
        toDateInputValue(current.expectedArrivalDate)
      )
        mismatches.push(basketProduct.name);
      const refreshed = {
        ...basketProduct,
        state: current.state,
        maxQuantity: current.quantity,
        stockQuantity: current.stockQuantity,
        preorderQuantity: current.preorderQuantity,
        expectedArrivalDate: current.expectedArrivalDate || null,
      };
      if (basketProduct.price != null && basketProduct.discountedPrice != null && current.price != null && current.discountedPrice != null &&
          Number(basketProduct.price) === Number(current.price) && Number(basketProduct.discountedPrice) === Number(current.discountedPrice)) {
        refreshed.personalDiscount = current.personalDiscount;
        refreshed.productDiscount = current.productDiscount;
      }
      const productChanged = availabilityChanged(basketProduct, refreshed);
      changed = changed || productChanged;
      updatedProducts.push(productChanged ? refreshed : basketProduct);
    } catch (error) {
      // A failed read cannot turn existing availability into a zero balance.
      updatedProducts.push(basketProduct);
    }
  }
  return isCurrent() ? { products: updatedProducts, changed, mismatches } : null;
}
